import { useState } from "react";
import { motion } from "framer-motion";
import { LabButton } from "./LabButton";
import { MENU_ITEMS } from "../data/site";
import { revealUp, staggerParent, viewportOnce } from "../lib/motion";

export const MenuPreview = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <section
      data-testid="menu-preview-section"
      className="bg-offwhite py-24 sm:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          variants={staggerParent}
          className="mb-16 max-w-2xl"
        >
          <motion.p variants={revealUp} className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-labred">
            03 / TESTED &amp; APPROVED
          </motion.p>
          <motion.h2
            variants={revealUp}
            className="font-display text-3xl leading-[1.05] tracking-tight text-charcoal sm:text-5xl"
          >
            THE RESULTS SPEAK FOR THEMSELVES.
          </motion.h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          variants={staggerParent}
          className="grid grid-cols-1 gap-8 md:grid-cols-3"
        >
          {MENU_ITEMS.map((item, i) => (
            <motion.div
              key={item.name}
              variants={revealUp}
              data-testid={`menu-item-${i + 1}`}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              className="group"
            >
              <div className="relative aspect-square overflow-hidden rounded-[3px] bg-charcoal">
                <img
                  src={item.img}
                  alt={item.name}
                  loading="lazy"
                  decoding="async"
                  className={`h-full w-full object-cover transition-all duration-500 ease-out group-hover:scale-105 ${
                    hovered !== null && hovered !== i ? "grayscale" : "grayscale-0"
                  }`}
                />
              </div>
              <div className="mt-5">
                <h3 className="font-display text-lg uppercase leading-tight tracking-tight text-charcoal">
                  {item.name}
                </h3>
              </div>
              <p className="mt-2 font-body text-sm leading-relaxed text-charcoal/70">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportOnce}
          transition={{ duration: 0.6 }}
          className="mt-16 flex justify-center"
        >
          <LabButton to="/menu" variant="red" testId="view-full-menu-button">
            View the Full Menu
          </LabButton>
        </motion.div>
      </div>
    </section>
  );
};
